import styled from 'styled-components';

import { responsive, sp } from '@main/theme';

/**
 * The panel wrapper props
 */
export interface PanelWrapperProps {
  /** The number of rows to render in the button panel */
  rowCount: number;
}

/**
 * The Panel Wrapper
 */
export const PanelWrapper = styled.div<PanelWrapperProps>`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${responsive.atLeastTablet} {
    display: grid;
    grid-template-rows: ${({ rowCount }) => `repeat(${rowCount}, max-content)`};
    grid-template-columns: repeat(2, 0.8fr);
    width: fit-content;
    row-gap: ${sp(2)};
    column-gap: ${sp(2)};
  }
`;

/**
 * The ActionButton Wrapper
 */
export const ActionButtonWrapper = styled.div`
  width: 100%;
  height: 100%;

  ${responsive.beforeTablet} {
    margin: ${sp(1)};
  }
`;
